import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import {
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Bar,
  Line,
  ResponsiveContainer,
  Sector,
} from "recharts";
import { PieChart, Pie, Cell } from "recharts";
import { FaRupeeSign } from "react-icons/fa"; // Import the rupee icon
import {
  FaUsers,
  FaGlobe,
  FaChartLine,
  FaArrowDown,
  FaRegHandshake,
  FaTimesCircle,
} from "react-icons/fa";
import { generateRandomColor } from "make-random-color";
import { Package } from "lucide-react";
import { BaseUrl } from "../App";
import { FadeLoader } from "react-spinners";

const AdminDashboard = () => {
  const [totalStaffCount, setTotalStaffCount] = useState(null);
  const [Totalbookingcount, setTotalbookingcount] = useState(null);
  const [TotalBookingComplete, setTotalBookingComplete] = useState(null);
  const [TotalBookingConfirm, setTotalBookingConfirm] = useState(null);
  const [TotalBookingCancelByProvider, setTotalBookingCancelByProvider] =
    useState(null);
  const [TotalBookingReject, setTotalBookingReject] = useState(null);
  const [serviceCount, setServiceCount] = useState(null);
  const [payment, setpayment] = useState(null);
  const [Customer, setCustomer] = useState([]);
  const [TotalOrderCount, setTotalOrderCount] = useState([]);
  const [TotalProfit, setTotalProfit] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [totalNetAmount, setTotalNetAmount] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serviceTypeData, setServiceTypeData] = useState([]);
  console.log(serviceCount);

  const cardShadowClass = "shadow-lg";
  const [pieData, setPieData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  // const monthlyBookings = [
  //   { month: 'Jan', residentialBookings: 40, commercialBookings: 25 },
  //   { month: 'Feb', residentialBookings: 35, commercialBookings: 28 },
  //   { month: 'Mar', residentialBookings: 42, commercialBookings: 30 },
  //   { month: 'Apr', residentialBookings: 38, commercialBookings: 35 },
  //   { month: 'May', residentialBookings: 45, commercialBookings: 40 },
  //   { month: 'Jun', residentialBookings: 50, commercialBookings: 38 },
  //   { month: 'Jul', residentialBookings: 55, commercialBookings: 42 },
  //   { month: 'Aug', residentialBookings: 60, commercialBookings: 45 },
  //   { month: 'Sep', residentialBookings: 52, commercialBookings: 40 },
  // ];
  const navigate = useNavigate();

  const renderActiveShape = (props) => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
    } = props;
    return (
      <g>
        <text
          x={cx}
          y={cy}
          dy={8}
          textAnchor="middle"
          fill={fill}
          className="text-sm font-medium"
        >
          {`${payload.name}`}
        </text>
        <text
          x={cx}
          y={cy + 20}
          textAnchor="middle"
          fill={fill}
          className="text-xs"
        >
          {`${(percent * 100).toFixed(1)}%`}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 5}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };

  useEffect(() => {
    const fetchServiceData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "AllserviceCount" }
        );
        if (response.data && response.data.services) {
          const transformedData = response.data.services.map((service) => ({
            name: service.title,
            value: parseInt(service.service_count),
            color: generateRandomColor(),
          }));
          setServiceTypeData(
            transformedData.filter((service) => service.value > 0)
          );
        } else {
          console.error("Invalid response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching service data:", error);
      }  finally {
        setLoading(false);
      }
    };

    fetchServiceData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php `,
          { action: "monthly" }
        );
        console.log(response.data); // Check the API response in the console

        // Update totalNetAmount with the value from the API response
        const netAmount = parseFloat(response.data.total_net_amount);
        setTotalNetAmount(netAmount);

        // Map the API response to the format required for the chart
        const formattedData = response.data.monthly_data.map((item) => ({
          name: `${item.year}-${item.month}`,
          sales: parseFloat(item.booking_count),
          average: 20, // Set average value or modify as required
        }));

        setMonthlyData(formattedData);
      } catch (error) {
        console.error("Error fetching monthly data:", error);
      }  finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchTotalStaff = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "totalstaff" }
        );
        console.log(response.data);
        setTotalStaffCount(response.data.totalstaff);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalStaff();
  }, []);

  useEffect(() => {
    const fetchBooking = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "bookingcount" }
        );
        console.log(response.data);
        setTotalbookingcount(response.data.bookingcount);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }

    };

    fetchBooking();
  }, []);

  useEffect(() => {
    
    const fetchBookingComplete = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "bookingcountcomplate" }
        );
        console.log(response.data);
        setTotalBookingComplete(response.data.bookingcountcomplate);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingComplete();
  }, []);

  useEffect(() => {
    const fetchBookingConfirm = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "bookingcountconfirm" }
        );
        console.log(response.data);
        setTotalBookingConfirm(response.data.bookingcountconfirm);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingConfirm();
  }, []);

  useEffect(() => {
    const fetchBookingCancelByProvider = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "bookingcountCancelprovider" }
        );
        console.log(response.data);
        setTotalBookingCancelByProvider(
          response.data.bookingcountCancelprovider
        );
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingCancelByProvider();
  }, []);

  useEffect(() => {
    const fetchBookingReject = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "bookingcountReject" }
        );
        console.log(response.data);
        setTotalBookingReject(response.data.bookingcountReject);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingReject();
  }, []);

  useEffect(() => {
    const fetchServiceCount = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "servicecount" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setServiceCount(response.data); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching service count:", error);
      }   finally {
        setLoading(false);
      }
    };

    fetchServiceCount();
  }, []);

  useEffect(() => {
    const fetchpayment = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "payment" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setpayment(response.data); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching service count:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchpayment();
  }, []);

  useEffect(() => {
    const fetchCustomer = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "customer" }
        );
        console.log(response.data); // Check the structure of the response data
        // Assuming the response contains data like `value` and `growth`
        setCustomer(response.data.total_user_count); // Adjust this based on the response structure
      } catch (error) {
        console.error("Error fetching Coustomer count:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, []);

  useEffect(() => {
    const fetchTotalOrder = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "totalorder" }
        );
        console.log(response.data);
        setTotalOrderCount(response.data.total_bookings);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalOrder();
  }, []);

  useEffect(() => {
    const fetchTotalProfit = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          { action: "total_profit" }
        );
        console.log(response.data);
        setTotalProfit(response.data.total_profit);
      } catch (error) {
        console.error("Error fetching total staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalProfit();
  }, []);

  useEffect(() => {
    setLoading(true);

    const fetchAllBooking = async () => {
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/dashboard.php`,
          {
            action: "allBooking",
          }
        );

        const {
          today_booking_count,
          upcoming_booking_count,
          past_booking_count,
        } = response.data;

        const transformedData = [
          { name: "Today", value: today_booking_count, color: "#60A5FA" },
          { name: "Upcoming", value: upcoming_booking_count, color: "#93C5FD" },
          { name: "Past", value: past_booking_count, color: "#3B82F6" },
        ];
        console.log(transformedData);

        setPieData(transformedData);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setLoading(false);
      } 
    };

    fetchAllBooking();
  }, []);

  const StatCard = ({ icon, value, label, id, color, onClick }) => {
    const [hoveredCard, setHoveredCard] = React.useState(null);
    const isHovered = hoveredCard === id;

    return (
      <div
        className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 ${
          isHovered ? "transform scale-105 shadow-lg" : ""
        } hover:bg-blue-50 animate-fadeIn border border-gray-200`}
        onMouseEnter={() => setHoveredCard(id)}
        onMouseLeave={() => setHoveredCard(null)}
        onClick={onClick}
      >
        {/* Flex Container for Proper Alignment */}
        <div className="flex items-center justify-between">
          {/* Left Section: Icon & Label */}
          <div className="flex items-center gap-2">
            <div
              className={`p-2 ${color} text-white rounded-full transition-transform duration-300 ${
                isHovered ? "scale-110" : ""
              }`}
            >
              {icon}
            </div>
            <div className="text-gray-500 text-xs uppercase">{label}</div>
          </div>

          {/* Right Section: Value (Highlighted) */}
          <div className="text-2xl font-bold text-blue-600">{value}</div>
        </div>
      </div>
    );
  };

  const MetricCard = ({
    title,
    value,
    subtitle,
    children,
    className,
    color = "bg-blue-800",
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 ${className} ${
          isHovered ? "transform scale-102 shadow-md" : ""
        } animate-slideIn hover:bg-blue-50 border border-gray-200`} // Added border class
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className={`text-sm ${color} font-medium mb-1`}>{title}</div>
        <div className="text-3xl font-bold mb-1 animate-countUp">{value}</div>
        <div className="text-xs text-gray-500 mb-4">{subtitle}</div>
        {children}
      </div>
    );
  };

  const LargeMetricCard = ({ title, value, icon, className, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`p-6 rounded-lg shadow-sm flex items-center justify-between transition-transform duration-300 ${className} ${
          isHovered ? "transform scale-102 shadow-md" : ""
        } animate-slideInRight border border-gray-200`} // Added border class
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        <div>
          <div className="text-sm mb-1">{title}</div>
          <div className="text-2xl font-bold animate-countUp">{value}</div>
        </div>
        <div
          className={`p-3 rounded-full transition-transform duration-300 ${
            isHovered ? "scale-110" : ""
          }`}
        >
          {icon}
        </div>
      </div>
    );
  };

  const BottomStatCard = ({ title, value, growth, color }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 
          ${isHovered ? "transform scale-105 shadow-md" : ""} 
          animate-fadeIn hover:bg-blue-50 border border-gray-200`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Flexbox to align text and number in one line */}
        <div className="flex items-center justify-between w-full">
          {/* Left Side: Title & Growth */}
          <div>
            <div className="text-sm text-gray-500">{title}</div>
            <div className="text-xs text-gray-400">{growth}</div>
          </div>

          {/* Right Side: Number (Highlighted) */}
          <div
            className={`text-2xl font-bold ${color} bg-yellow-200 px-3 py-1 rounded-md`}
          >
            {value}
          </div>
        </div>
      </div>
    );
  };
  const CustomerCard = ({
    title,
    value,
    serviceCount,
    theme = "light",
    onClick,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const data = [
      {
        name: "Total Services Disable",
        value: parseInt(serviceCount?.total_disable_service_count) || 0,
        color: theme === "dark" ? "#60F0C8" : "#3B82F6",
      },
      {
        name: "Total Services Enable",
        value: parseInt(serviceCount?.total_enabled_service_count) || 0,
        color: theme === "dark" ? "#FFFFFF" : "#22D3EE",
      },
    ];

    console.log("Service Data:", data);

    return (
      <div
        className={`p-6 rounded-lg shadow-sm transition-transform duration-300 ${
          isHovered ? "transform scale-105 shadow-md" : ""
        } animate-fadeIn ${
          theme === "dark" ? "bg-blue-500 text-white" : "bg-white text-gray-800"
        } border border-gray-200 h-full flex flex-col justify-between cursor-pointer`} // Added cursor-pointer
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick} // Added onClick handler
      >
        <div>
          <div className="flex justify-between items-center mb-3">
            <div className="text-lg font-medium">{title}</div>
          </div>
          <div className="text-4xl font-bold mb-3 animate-countUp">{value}</div>
          <div className="flex items-center">
            <div className="w-1/2 h-32">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={30}
                    outerRadius={45}
                    paddingAngle={5}
                    dataKey="value"
                    startAngle={90}
                    endAngle={-270}
                    animationDuration={1000}
                    animationBegin={0}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color}
                        className="transition-transform duration-300"
                        style={{
                          transform: isHovered ? "scale(1.1)" : "scale(1)",
                        }}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="w-1/2">
              {data.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center mb-2 transition-transform duration-300 ${
                    isHovered ? "transform translate-x-1" : ""
                  }`}
                >
                  <div
                    className="w-3 h-3 rounded-full mr-2 transition-transform duration-300"
                    style={{
                      backgroundColor: item.color,
                      transform: isHovered ? "scale(1.2)" : "scale(1)",
                    }}
                  ></div>
                  <div
                    className={`text-sm ${
                      theme === "dark" ? "text-white" : "text-gray-700"
                    }`}
                  >
                    {item.value} {item.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CustomerCarddata = ({
    title,
    value,
    payment,
    theme = "light",
    onClick,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const data = [
      {
        name: "Total Payment Pending",
        value: parseInt(payment?.pending_count) || 0,
        color: theme === "dark" ? "#60F0C8" : "#3B82F6",
      },
      {
        name: "Total Payment Completed",
        value: parseInt(payment?.completed_count) || 0,
        color: theme === "dark" ? "#FFFFFF" : "#22D3EE",
      },
    ];

    console.log("Payment Data:", data);

    return (
      <div
        className={`p-6 rounded-lg shadow-sm transition-transform duration-300 ${
          isHovered ? "transform scale-105 shadow-md" : ""
        } animate-fadeIn ${
          theme === "dark" ? "bg-blue-500 text-white" : "bg-white text-gray-800"
        } border border-gray-200 h-full flex flex-col justify-between cursor-pointer`} // Added cursor-pointer
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick} // Added onClick handler
      >
        <div>
          <div className="flex justify-between items-center mb-3">
            <div className="text-lg font-medium">{title}</div>
          </div>
          <div className="text-4xl font-bold mb-3 animate-countUp">{value}</div>
          <div className="flex items-center">
            <div className="w-1/2 h-32">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={30}
                    outerRadius={45}
                    paddingAngle={5}
                    dataKey="value"
                    startAngle={90}
                    endAngle={-270}
                    animationDuration={1000}
                    animationBegin={0}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color}
                        className="transition-transform duration-300"
                        style={{
                          transform: isHovered ? "scale(1.1)" : "scale(1)",
                        }}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="w-1/2">
              {data.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-center mb-2 transition-transform duration-300 ${
                    isHovered ? "transform translate-x-1" : ""
                  }`}
                >
                  <div
                    className="w-3 h-3 rounded-full mr-2 transition-transform duration-300"
                    style={{
                      backgroundColor: item.color,
                      transform: isHovered ? "scale(1.2)" : "scale(1)",
                    }}
                  ></div>
                  <div
                    className={`text-sm ${
                      theme === "dark" ? "text-white" : "text-gray-700"
                    }`}
                  >
                    {item.value} {item.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const chartColors = {
    bar: "#3B82F6",
    line: "#10B981",
    barHover: "#2563EB",
    grid: "#E5E7EB",
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         

    <div className="p-6 min-h-screen text-black">
      {/* Stats Grid - Responsive */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 cursor-grab cursor-grabbing lg:grid-cols-6 gap-5 mb-4"> */}
     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 mb-4 cursor-grab active:cursor-grabbing">

        <StatCard
          id="customers"
          icon={<FaRegHandshake size={20} />}
          value={Totalbookingcount}
          label="Active Bookings"
          color="bg-blue-800"
          onClick={() => navigate("/admin/appointment")} // Navigate to appointments
        />

        <StatCard
          id="revenue"
          icon={<FaGlobe size={20} />}
          value={TotalBookingComplete}
          label="Booking Complete"
          color="bg-blue-800"
          onClick={() => navigate("/admin/appointment")} // Navigate to appointments
        />
        <StatCard
          id="growth"
          icon={<FaChartLine size={20} />}
          value={TotalBookingConfirm}
          label="Booking Confirm"
          color="bg-blue-800"
          onClick={() => navigate("/admin/appointment")} // Navigate to appointments
        />
        <StatCard
          id="returns"
          icon={<FaArrowDown size={20} />}
          value={TotalBookingCancelByProvider}
          label="Booking Cancel by Provider"
          color="bg-blue-800"
          onClick={() => navigate("/admin/appointment")} // Navigate to appointments
        />
        <StatCard
          id="growth"
          icon={<FaTimesCircle size={20} />}
          value={TotalBookingReject}
          label="Booking Reject by Admin"
          color="bg-blue-800"
          onClick={() => navigate("/admin/appointment")} // Navigate to appointments
        />
        <StatCard
          id="totalStaff"
          icon={<FaUsers size={20} />}
          value={totalStaffCount}
          label="TOTAL STAFF"
          color="bg-blue-800"
          onClick={() => navigate("/admin/staff")} // Navigate to appointments
        />
      </div>

      {/* Large Metric Cards Grid - Responsive */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3  cursor-grab active:cursor-grabbing gap-4 mb-4">
        <LargeMetricCard
          title="Total Customer"
          value={Customer}
          icon={<Package size={24} className="text-white" />}
          className="bg-blue-800 text-white"
          onClick={() => navigate("/admin/crm")}
        />
        <LargeMetricCard
          title="Total Profit"
          value={parseFloat(TotalProfit).toFixed(2)} // Correct usage
          icon={<FaRupeeSign size={24} className="text-blue-800" />}
          className="bg-white text-gray-800"
          onClick={() => navigate("/admin/payment")} // Navigate to appointments
        />

        <LargeMetricCard
          title="Total Orders"
          value={TotalOrderCount}
          icon={<Package size={24} className="text-white" />}
          className="bg-white text-gray-800"
          onClick={() => navigate("/admin/export")} // Navigate to appointments
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2  cursor-grab active:cursor-grabbing  lg:grid-cols-3 gap-4 mb-4">
        {/* Service Type Distribution Chart */}
        <div
          className={`bg-white rounded-lg ${cardShadowClass}  p-4 transform transition-all duration-500 hover:shadow-xl h-96`}
          style={{
            animation: "fadeInLeft 0.6s ease-out forwards",
            opacity: serviceTypeData.length > 0 ? 1 : 0,
            transform:
              serviceTypeData.length > 0
                ? "translateX(0)"
                : "translateX(-20px)",
          }}
          onClick={() => navigate("/admin/export/serviceInformation")} // Navigate to services
        >
          <h3 className="text-lg font-medium mb-4">
            Service Booking Information
          </h3>

          {serviceTypeData.length > 0 ? (
            <div className="h-64 w-full">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    activeIndex={activeIndex}
                    activeShape={renderActiveShape}
                    data={serviceTypeData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    dataKey="value"
                    onMouseEnter={onPieEnter}
                  >
                    {serviceTypeData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div className="flex items-center justify-center h-64 w-full text-gray-500">
              No data available to display.
            </div>
          )}

          {serviceTypeData.length > 0 && (
            <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mt-3">
              {serviceTypeData.map((item) => (
                <div key={item.name} className="flex items-center">
                  <div
                    className="w-3 h-3 rounded-full mr-1 sm:mr-2"
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <span className="text-xs sm:text-sm text-gray-600">
                    {item.name}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Services Details Card */}
        <div className="h-96">
          <CustomerCard
            title="Services Details"
            value={
              serviceCount ? serviceCount.total_service_count : "Loading..."
            }
            serviceCount={serviceCount}
            onClick={() => navigate("/admin/service")}
          />
        </div>

        {/* Payment Details Card */}
        <div className="h-96">
          <CustomerCarddata
            title="Payment Details"
            value={payment ? payment.total_count : "Loading..."}
            payment={payment}
            theme="dark"
            onClick={() => navigate("/admin/payment")}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        {/* Pie Chart Section */}
        <div className="col-span-1 bg-white text-gray-800 p-4 rounded-lg shadow-sm animate-fadeIn border border-gray-200">
          <div className="text-gray-700 font-medium mb-2">
            All Booking Detail
          </div>
          <div className="text-sm text-gray-500 mb-4">
            Past Booking, Today Booking, Future Booking – These all are the
            types of data fetched.
          </div>
          <div className="h-48">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={0}
                  outerRadius={80}
                  paddingAngle={2}
                  dataKey="value"
                  animationDuration={1000}
                  animationBegin={0}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
            {pieData.map((item, index) => (
              <div
                key={index}
                className="flex items-center transition-transform duration-300 hover:scale-105"
              >
                <div
                  className="w-3 h-3 rounded-full mr-2"
                  style={{ backgroundColor: item.color }}
                ></div>
                <div className="text-xs">{item.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Bar Chart Section */}
        <div className="col-span-1 md:col-span-2 bg-white text-gray-800 p-4 rounded-lg shadow-sm animate-slideIn border border-gray-200">
          <div className="mb-4">
            <div className="text-gray-700 font-medium mb-1">
              Monthly Wise Order Report
            </div>
            <div className="text-2xl font-bold text-blue-600 animate-countUp">
              {totalNetAmount !== null
                ? `₹${totalNetAmount.toFixed(2)}`
                : "Loading..."}
            </div>
            <div className="text-sm text-gray-500">Total Order</div>
          </div>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={monthlyData}>
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                stroke="#eee"
              />
              <XAxis dataKey="name" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip
                formatter={(value, name) => {
                  if (name === "sales") {
                    return [`${value}`, "Orders"];
                  }
                  return [`${value}`, name];
                }}
              />
              <Bar
                dataKey="sales"
                fill="#3B82F6"
                radius={[4, 4, 0, 0]}
                animationDuration={1500}
              />
              <Line
                type="monotone"
                dataKey="average"
                stroke="#10B981"
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 6, fill: "#10B981" }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  </div>
  );
};

export default AdminDashboard;

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   BarChart,
//   LineChart,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   Bar,
//   Line,
//   ResponsiveContainer,
// } from "recharts";
// import { PieChart, Pie, Cell } from "recharts";
// import { FaRupeeSign } from "react-icons/fa"; // Import the rupee icon
// import {
//   FaUsers,
//   FaGlobe,
//   FaChartLine,
//   FaArrowDown,
//   FaRegHandshake,
//   FaTimesCircle,
// } from "react-icons/fa";
// import {
//   Users,
//   Globe,
//   TrendingUp,
//   ArrowDownCircle,
//   DollarSign,
//   Package,
// } from "lucide-react";
// import { BaseUrl } from "../App";
// const AdminDashboard = () => {
//   const [totalStaffCount, setTotalStaffCount] = useState(null);
//   const [Totalbookingcount, setTotalbookingcount] = useState(null);
//   const [TotalBookingComplete, setTotalBookingComplete] = useState(null);
//   const [TotalBookingConfirm, setTotalBookingConfirm] = useState(null);
//   const [TotalBookingCancelByProvider, setTotalBookingCancelByProvider] =
//     useState(null);
//   const [TotalBookingReject, setTotalBookingReject] = useState(null);
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [serviceCount, setServiceCount] = useState(null);
//   const [payment, setpayment] = useState(null);
//   const [Customer, setCustomer] = useState([]);
//   const [TotalOrderCount, setTotalOrderCount] = useState([]);
//   const [TotalProfit, setTotalProfit] = useState([]);
//   const [monthlyData, setMonthlyData] = useState([]);
//   const [totalNetAmount, setTotalNetAmount] = useState(null);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [UpcomingBookingCount, setAllBooking] = useState(null);
//   const [staffId, setStaffId] = useState(null); // State to hold staff ID
//   console.log(serviceCount);

//   const orderData = [
//     { day: "1", value: 10 },
//     { day: "2", value: 15 },
//     { day: "3", value: 8 },
//     { day: "4", value: 12 },
//     { day: "5", value: 5 },
//     { day: "6", value: 10 },
//     { day: "7", value: 7 },
//     { day: "8", value: 16 },
//     { day: "9", value: 9 },
//     { day: "10", value: 12 },
//     { day: "11", value: 14 },
//     { day: "12", value: 16 },
//     { day: "13", value: 8 },
//     { day: "14", value: 12 },
//     { day: "15", value: 5 },
//   ];

//   const [pieData, setPieData] = useState([]);

//   const visitorData = [
//     { month: "Jan", arts: 20, commerce: 60 },
//     { month: "Feb", arts: 50, commerce: 30 },
//     { month: "Mar", arts: 30, commerce: 40 },
//     { month: "Apr", arts: 60, commerce: 45 },
//     { month: "May", arts: 30, commerce: 65 },
//     { month: "Jun", arts: 50, commerce: 35 },
//   ];

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php `,
//           { action: "monthly" }
//         );
//         console.log(response.data); // Check the API response in the console

//         // Update totalNetAmount with the value from the API response
//         const netAmount = parseFloat(response.data.total_net_amount);
//         setTotalNetAmount(netAmount);

//         // Map the API response to the format required for the chart
//         const formattedData = response.data.monthly_data.map((item) => ({
//           name: `${item.year}-${item.month}`,
//           sales: parseFloat(item.booking_count),
//           average: 20, // Set average value or modify as required
//         }));

//         setMonthlyData(formattedData);
//       } catch (error) {
//         console.error("Error fetching monthly data:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const fetchTotalStaff = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "totalstaff" }
//         );
//         console.log(response.data);
//         setTotalStaffCount(response.data.totalstaff);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchTotalStaff();
//   }, []);

//   useEffect(() => {
//     const fetchBooking = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "bookingcount" }
//         );
//         console.log(response.data);
//         setTotalbookingcount(response.data.bookingcount);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchBooking();
//   }, []);

//   useEffect(() => {
//     const fetchBookingComplete = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "bookingcountcomplate" }
//         );
//         console.log(response.data);
//         setTotalBookingComplete(response.data.bookingcountcomplate);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchBookingComplete();
//   }, []);

//   useEffect(() => {
//     const fetchBookingConfirm = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "bookingcountconfirm" }
//         );
//         console.log(response.data);
//         setTotalBookingConfirm(response.data.bookingcountconfirm);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchBookingConfirm();
//   }, []);

//   useEffect(() => {
//     const fetchBookingCancelByProvider = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "bookingcountCancelprovider" }
//         );
//         console.log(response.data);
//         setTotalBookingCancelByProvider(
//           response.data.bookingcountCancelprovider
//         );
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchBookingCancelByProvider();
//   }, []);

//   useEffect(() => {
//     const fetchBookingReject = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "bookingcountReject" }
//         );
//         console.log(response.data);
//         setTotalBookingReject(response.data.bookingcountReject);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchBookingReject();
//   }, []);

//   useEffect(() => {
//     const fetchServiceCount = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "servicecount" }
//         );
//         console.log(response.data); // Check the structure of the response data
//         // Assuming the response contains data like `value` and `growth`
//         setServiceCount(response.data); // Adjust this based on the response structure
//       } catch (error) {
//         console.error("Error fetching service count:", error);
//       }
//     };

//     fetchServiceCount();
//   }, []);

//   useEffect(() => {
//     const fetchpayment = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "payment" }
//         );
//         console.log(response.data); // Check the structure of the response data
//         // Assuming the response contains data like `value` and `growth`
//         setpayment(response.data); // Adjust this based on the response structure
//       } catch (error) {
//         console.error("Error fetching service count:", error);
//       }
//     };

//     fetchpayment();
//   }, []);

//   useEffect(() => {
//     const fetchCustomer = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "customer" }
//         );
//         console.log(response.data); // Check the structure of the response data
//         // Assuming the response contains data like `value` and `growth`
//         setCustomer(response.data.total_user_count); // Adjust this based on the response structure
//       } catch (error) {
//         console.error("Error fetching Coustomer count:", error);
//       }
//     };

//     fetchCustomer();
//   }, []);

//   useEffect(() => {
//     const fetchTotalOrder = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "totalorder" }
//         );
//         console.log(response.data);
//         setTotalOrderCount(response.data.total_bookings);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchTotalOrder();
//   }, []);

//   useEffect(() => {
//     const fetchTotalProfit = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           { action: "total_profit" }
//         );
//         console.log(response.data);
//         setTotalProfit(response.data.total_profit);
//       } catch (error) {
//         console.error("Error fetching total staff:", error);
//       }
//     };

//     fetchTotalProfit();
//   }, []);

//   useEffect(() => {
//     setIsLoaded(true);

//     const fetchAllBooking = async () => {
//       try {
//         const response = await axios.post(
//           `${BaseUrl}/backend/api/dashboard.php`,
//           {
//             action: "allBooking",
//           }
//         );

//         const {
//           today_booking_count,
//           upcoming_booking_count,
//           past_booking_count,
//         } = response.data;

//         const transformedData = [
//           { name: "Today", value: today_booking_count, color: "#60A5FA" },
//           { name: "Upcoming", value: upcoming_booking_count, color: "#93C5FD" },
//           { name: "Past", value: past_booking_count, color: "#3B82F6" },
//         ];
//         console.log(transformedData);

//         setPieData(transformedData);
//       } catch (error) {
//         console.error("Error fetching bookings:", error);
//       }
//     };

//     fetchAllBooking();
//   }, []);

//   const StatCard = ({ icon, value, label, id, color }) => {
//     const isHovered = hoveredCard === id;

//     return (
//       <div
//         className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 ${
//           isHovered ? "transform scale-105 shadow-lg" : ""
//         } hover:bg-blue-50 animate-fadeIn border border-gray-200`} // Added border class
//         onMouseEnter={() => setHoveredCard(id)}
//         onMouseLeave={() => setHoveredCard(null)}
//       >
//         <div className="flex items-center mb-2">
//           <div
//             className={`p-2 ${color} text-white rounded-full transition-transform duration-300 ${
//               isHovered ? "scale-110" : ""
//             }`}
//           >
//             {icon}
//           </div>
//           <div className="ml-3">
//             <div className="text-gray-500 text-xs uppercase">{label}</div>
//             <div className="text-2xl font-semibold animate-countUp">
//               {value}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const MetricCard = ({
//     title,
//     value,
//     subtitle,
//     children,
//     className,
//     color = "bg-blue-800",
//   }) => {
//     const [isHovered, setIsHovered] = useState(false);

//     return (
//       <div
//         className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 ${className} ${
//           isHovered ? "transform scale-102 shadow-md" : ""
//         } animate-slideIn hover:bg-blue-50 border border-gray-200`} // Added border class
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div className={`text-sm ${color} font-medium mb-1`}>{title}</div>
//         <div className="text-3xl font-bold mb-1 animate-countUp">{value}</div>
//         <div className="text-xs text-gray-500 mb-4">{subtitle}</div>
//         {children}
//       </div>
//     );
//   };

//   const LargeMetricCard = ({ title, value, icon, className }) => {
//     const [isHovered, setIsHovered] = useState(false);

//     return (
//       <div
//         className={`p-6 rounded-lg shadow-sm flex items-center justify-between transition-transform duration-300 ${className} ${
//           isHovered ? "transform scale-102 shadow-md" : ""
//         } animate-slideInRight border border-gray-200`} // Added border class
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div>
//           <div className="text-sm mb-1">{title}</div>
//           <div className="text-2xl font-bold animate-countUp">{value}</div>
//         </div>
//         <div
//           className={`p-3 rounded-full transition-transform duration-300 ${
//             isHovered ? "scale-110" : ""
//           }`}
//         >
//           {icon}
//         </div>
//       </div>
//     );
//   };

//   const BottomStatCard = ({ title, value, growth, color }) => {
//     const [isHovered, setIsHovered] = useState(false);

//     return (
//       <div
//         className={`bg-white p-4 rounded-lg shadow-sm transition-transform duration-300 ${
//           isHovered ? "transform scale-105 shadow-md" : ""
//         } animate-fadeIn hover:bg-blue-50 border border-gray-200`} // Added border class
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div className="text-sm text-gray-500 mb-2">{title}</div>
//         <div className={`text-2xl font-bold ${color} mb-1 animate-countUp`}>
//           {value}
//         </div>
//         <div className="text-xs text-gray-500">{growth}</div>
//       </div>
//     );
//   };

//   const CustomerCard = ({ title, value, growth, theme = "light" }) => {
//     const [isHovered, setIsHovered] = useState(false);

//     const data = [
//       //   { name: 'Now', value: 30, color: theme === 'dark' ? '#60F0C8' : '#3B82F6' },
//       //   { name: 'Return', value: 70, color: theme === 'dark' ? '#FFFFFF' : '#22D3EE' }
//       {
//         name: "Total Services Disable",
//         value: parseInt(serviceCount?.total_disable_service_count),
//         color: theme === "dark" ? "#60F0C8" : "#3B82F6",
//       },
//       {
//         name: "Total Services Enable",
//         value: parseInt(serviceCount?.total_enabled_service_count),
//         color: theme === "dark" ? "#FFFFFF" : "#22D3EE",
//       },
//     ];

//     console.log(data);

//     return (
//       <div
//         className={`p-6 rounded-lg shadow-sm transition-transform duration-300 ${
//           isHovered ? "transform scale-105 shadow-md" : ""
//         } animate-fadeIn ${
//           theme === "dark" ? "bg-blue-500 text-white" : "bg-white text-gray-800"
//         } border border-gray-200`} // Added border class
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div className="flex justify-between items-center mb-3">
//           <div className="text-lg font-medium">{title}</div>
//           {/* <div className={`text-xs px-2 py-1 rounded-full ${
//             theme === "dark" ? "bg-blue-200 text-blue-800" : "bg-green-100 text-green-600"
//           }`}>
//             {growth}
//           </div> */}
//         </div>
//         <div className="text-4xl font-bold mb-3 animate-countUp">{value}</div>
//         <div className="flex items-center">
//           <div className="w-1/2 h-32">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={data}
//                   cx="50%"
//                   cy="50%"
//                   innerRadius={30}
//                   outerRadius={45}
//                   paddingAngle={5}
//                   dataKey="value"
//                   startAngle={90}
//                   endAngle={-270}
//                   animationDuration={1000}
//                   animationBegin={0}
//                 >
//                   {data.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={entry.color}
//                       className="transition-transform duration-300"
//                       style={{
//                         transform: isHovered ? "scale(1.1)" : "scale(1)",
//                       }}
//                     />
//                   ))}
//                 </Pie>
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="w-1/2">
//             {data.map((item, index) => (
//               <div
//                 key={index}
//                 className={`flex items-center mb-2 transition-transform duration-300 ${
//                   isHovered ? "transform translate-x-1" : ""
//                 }`}
//               >
//                 <div
//                   className="w-3 h-3 rounded-full mr-2 transition-transform duration-300"
//                   style={{
//                     backgroundColor: item.color,
//                     transform: isHovered ? "scale(1.2)" : "scale(1)",
//                   }}
//                 ></div>
//                 <div
//                   className={`text-sm ${
//                     theme === "dark" ? "text-white" : "text-gray-700"
//                   }`}
//                 >
//                   {item.value} {item.name}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {isHovered && (
//           <style jsx>{`
//             @keyframes pulse {
//               0% {
//                 transform: scale(1);
//               }
//               50% {
//                 transform: scale(1.05);
//               }
//               100% {
//                 transform: scale(1);
//               }
//             }
//             .animate-pulse-slow {
//               animation: pulse 2s infinite ease-in-out;
//             }
//           `}</style>
//         )}
//       </div>
//     );
//   };

//   const CustomerCarddata = ({ title, value, growth, theme = "light" }) => {
//     const [isHovered, setIsHovered] = useState(false);

//     const data = [
//       //   { name: 'Now', value: 30, color: theme === 'dark' ? '#60F0C8' : '#3B82F6' },
//       //   { name: 'Return', value: 70, color: theme === 'dark' ? '#FFFFFF' : '#22D3EE' }
//       {
//         name: "Total Payment Pending",
//         value: parseInt(payment?.pending_count),
//         color: theme === "dark" ? "#60F0C8" : "#3B82F6",
//       },
//       {
//         name: "Total Payment Completed",
//         value: parseInt(payment?.completed_count),
//         color: theme === "dark" ? "#FFFFFF" : "#22D3EE",
//       },
//     ];

//     console.log(data);

//     return (
//       <div
//         className={`p-6 rounded-lg shadow-sm transition-transform duration-300 ${
//           isHovered ? "transform scale-105 shadow-md" : ""
//         } animate-fadeIn ${
//           theme === "dark" ? "bg-blue-500 text-white" : "bg-white text-gray-800"
//         } border border-gray-200`} // Added border class
//         onMouseEnter={() => setIsHovered(true)}
//         onMouseLeave={() => setIsHovered(false)}
//       >
//         <div className="flex justify-between items-center mb-3">
//           <div className="text-lg font-medium">{title}</div>
//           {/* <div className={`text-xs px-2 py-1 rounded-full ${
//             theme === "dark" ? "bg-blue-200 text-blue-800" : "bg-green-100 text-green-600"
//           }`}>
//             {growth}
//           </div> */}
//         </div>
//         <div className="text-4xl font-bold mb-3 animate-countUp">{value}</div>
//         <div className="flex items-center">
//           <div className="w-1/2 h-32">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={data}
//                   cx="50%"
//                   cy="50%"
//                   innerRadius={30}
//                   outerRadius={45}
//                   paddingAngle={5}
//                   dataKey="value"
//                   startAngle={90}
//                   endAngle={-270}
//                   animationDuration={1000}
//                   animationBegin={0}
//                 >
//                   {data.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={entry.color}
//                       className="transition-transform duration-300"
//                       style={{
//                         transform: isHovered ? "scale(1.1)" : "scale(1)",
//                       }}
//                     />
//                   ))}
//                 </Pie>
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="w-1/2">
//             {data.map((item, index) => (
//               <div
//                 key={index}
//                 className={`flex items-center mb-2 transition-transform duration-300 ${
//                   isHovered ? "transform translate-x-1" : ""
//                 }`}
//               >
//                 <div
//                   className="w-3 h-3 rounded-full mr-2 transition-transform duration-300"
//                   style={{
//                     backgroundColor: item.color,
//                     transform: isHovered ? "scale(1.2)" : "scale(1)",
//                   }}
//                 ></div>
//                 <div
//                   className={`text-sm ${
//                     theme === "dark" ? "text-white" : "text-gray-700"
//                   }`}
//                 >
//                   {item.value} {item.name}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {isHovered && (
//           <style jsx>{`
//             @keyframes pulse {
//               0% {
//                 transform: scale(1);
//               }
//               50% {
//                 transform: scale(1.05);
//               }
//               100% {
//                 transform: scale(1);
//               }
//             }
//             .animate-pulse-slow {
//               animation: pulse 2s infinite ease-in-out;
//             }
//           `}</style>
//         )}
//       </div>
//     );
//   };

//   const chartColors = {
//     bar: "#3B82F6",
//     line: "#10B981",
//     barHover: "#2563EB",
//     grid: "#E5E7EB",
//   };

//   return (
//     <div className="p-6 min-h-screen text-black">
//       {/* Stats Grid - Responsive */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 mb-4">
//         <StatCard
//           id="customers"
//           icon={<FaRegHandshake size={20} />}
//           value={Totalbookingcount}
//           label="Active Bookings"
//           color="bg-blue-800"
//         />
//         <StatCard
//           id="revenue"
//           icon={<FaGlobe size={20} />}
//           value={TotalBookingComplete}
//           label="Booking Complete"
//           color="bg-blue-800"
//         />
//         <StatCard
//           id="growth"
//           icon={<FaChartLine size={20} />}
//           value={TotalBookingConfirm}
//           label="Booking Confirm"
//           color="bg-blue-800"
//         />
//         <StatCard
//           id="returns"
//           icon={<FaArrowDown size={20} />}
//           value={TotalBookingCancelByProvider}
//           label="Booking Cancel by Provider"
//           color="bg-blue-800"
//         />
//         <StatCard
//           id="growth"
//           icon={<FaTimesCircle size={20} />}
//           value={TotalBookingReject}
//           label="Booking Reject by Admin"
//           color="bg-blue-800"
//         />
//         <StatCard
//           id="totalStaff"
//           icon={<FaUsers size={20} />}
//           value={totalStaffCount}
//           label="TOTAL STAFF"
//           color="bg-blue-800"
//         />
//       </div>

//       {/* Large Metric Cards Grid - Responsive */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
//         <LargeMetricCard
//           title="Total Customer"
//           value={Customer}
//           icon={<Package size={24} className="text-white" />}
//           className="bg-blue-800 text-white"
//         />
//         <LargeMetricCard
//           title="Total Profit"
//           value={TotalProfit}
//           icon={<FaRupeeSign size={24} className="text-blue-800" />}
//           className="bg-white text-gray-800"
//         />
//         <LargeMetricCard
//           title="Total Orders"
//           value={TotalOrderCount}
//           icon={<Package size={24} className="text-white" />}
//           className="bg-white text-gray-800"
//         />
//       </div>
//       <div className="grid grid-cols-3 gap-4 mb-4">
//         <div className="col-span-1 bg-white text-gray-800 p-2 rounded-lg shadow-sm animate-fadeIn border border-gray-200">
//           <div className="flex justify-between items-center text-gray-700 font-medium mb-4">
//             <div>Unique Visitor</div>
//             <div className="flex space-x-2">
//               <div className="text-xs bg-blue-500 text-white px-2 py-1 rounded-full">
//                 Arts
//               </div>
//               <div className="text-xs bg-green-500 text-white px-2 py-1 rounded-full">
//                 Commerce
//               </div>
//             </div>
//           </div>
//           <ResponsiveContainer width="100%" height={200}>
//             <LineChart data={visitorData}>
//               <CartesianGrid
//                 strokeDasharray="3 3"
//                 vertical={false}
//                 stroke="#eee"
//               />
//               <XAxis dataKey="month" tick={{ fontSize: 10 }} />
//               <YAxis tick={{ fontSize: 10 }} />
//               <Tooltip />
//               <Line
//                 type="monotone"
//                 dataKey="arts"
//                 stroke="#3B82F6"
//                 strokeWidth={2}
//                 dot={{ fill: "#3B82F6", r: 4 }}
//                 activeDot={{ r: 6, fill: "#3B82F6" }}
//               />
//               <Line
//                 type="monotone"
//                 dataKey="commerce"
//                 stroke="#10B981"
//                 strokeWidth={2}
//                 dot={{ fill: "#10B981", r: 4 }}
//                 activeDot={{ r: 6, fill: "#10B981" }}
//               />
//             </LineChart>
//           </ResponsiveContainer>
//           <div className="flex mt-2"></div>
//         </div>

//         <div className="col-span-1">
//           {/* <CustomerCard
//                 title="Customers"
//                 value="826"
//                 growth="8.2%"
//             /> */}
//           <CustomerCard
//             title="Services Details"
//             value={
//               serviceCount ? serviceCount.total_service_count : "Loading..."
//             } // Dynamically set value
//             //   growth={serviceCount ? serviceCount.total_enabled_service_count : '0%'} // Dynamically set growth
//           />
//         </div>

//         <div className="col-span-1">
//           <CustomerCarddata
//             title="Payment Details"
//             value={payment ? payment.total_count : "Loading..."}
//             // growth="8.2%"
//             theme="dark"
//           />
//         </div>
//       </div>

//       <div className="grid grid-cols-3 gap-4 mb-4">
//         <div className="col-span-1 bg-white text-gray-800 p-4 rounded-lg shadow-sm animate-fadeIn border border-gray-200">
//           <div className="text-gray-700 font-medium mb-2">
//             All Booking Detail
//           </div>
//           <div className="text-sm text-gray-500 mb-4">
//             Past Booking Today Booking Future booking These All Are the Type
//             data Fetch{" "}
//           </div>
//           <div className="h-48">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={pieData}
//                   cx="50%"
//                   cy="50%"
//                   innerRadius={0}
//                   outerRadius={80}
//                   paddingAngle={2}
//                   dataKey="value"
//                   animationDuration={1000}
//                   animationBegin={0}
//                 >
//                   {pieData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={entry.color} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//           <div className="grid grid-cols-2 gap-2 mt-2">
//             {pieData.map((item, index) => (
//               <div
//                 key={index}
//                 className="flex items-center transition-transform duration-300 hover:scale-105"
//               >
//                 <div
//                   className="w-3 h-3 rounded-full mr-2"
//                   style={{ backgroundColor: item.color }}
//                 ></div>
//                 <div className="text-xs">{item.name}</div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="col-span-2 bg-white text-gray-800 p-4 rounded-lg shadow-sm animate-slideIn border border-gray-200">
//           <div className="mb-4">
//             <div className="text-gray-700 font-medium mb-1">
//               Monthly Wise Order Report
//             </div>
//             <div className="text-2xl font-bold text-blue-600 animate-countUp">
//               {totalNetAmount !== null
//                 ? `₹${totalNetAmount.toFixed(2)}`
//                 : "Loading..."}
//             </div>
//             <div className="text-sm text-gray-500">Total Order</div>
//           </div>
//           <ResponsiveContainer width="100%" height={200}>
//             <BarChart data={monthlyData}>
//               <CartesianGrid
//                 strokeDasharray="3 3"
//                 vertical={false}
//                 stroke="#eee"
//               />
//               <XAxis dataKey="name" tick={{ fontSize: 10 }} />
//               <YAxis tick={{ fontSize: 10 }} />
//               <Tooltip
//                 formatter={(value, name) => {
//                   if (name === "sales") {
//                     return [`${value}`, "Orders"]; // Customize the label here
//                   }
//                   return [`${value}`, name];
//                 }}
//               />
//               <Bar
//                 dataKey="sales"
//                 fill="#3B82F6"
//                 radius={[4, 4, 0, 0]}
//                 animationDuration={1500}
//               />
//               <Line
//                 type="monotone"
//                 dataKey="average"
//                 stroke="#10B981"
//                 strokeWidth={2}
//                 dot={false}
//                 activeDot={{ r: 6, fill: "#10B981" }}
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;
